var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7054 10.8562C32.851 10.0574 31.7381 9.65098 30.6293 9.63991L23.6641 9.57031L23.7291 15.6871L31.7983 15.7678C34.3726 15.7935 35.6511 12.6752 33.7054 10.8562Z",
    fill: "#FFCE71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5451 9.37962C15.4268 9.36851 14.3308 9.75244 13.4931 10.5346C12.7166 11.2595 12.242 12.2668 12.2539 13.385L15.5559 30.4643C15.5678 31.5824 15.0933 32.5897 14.3167 33.3146C13.4789 34.0968 12.3831 34.4807 11.2647 34.4696L27.444 34.6304C28.5623 34.6415 29.6582 34.2576 30.4959 33.4755C31.2724 32.7505 31.7471 31.7432 31.7351 30.6251C31.732 30.3303 28.4349 13.7086 28.4331 13.5458C28.4212 12.4276 28.383 11.4153 29.1596 10.6903C29.9974 9.90818 30.5805 9.51915 31.6989 9.53027L16.5451 9.37962Z",
    fill: "#FFEECB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8767 29.9235C16.8736 29.6311 15.9734 13.6505 15.9717 13.489C15.9599 12.3796 16.3815 11.3798 17.0722 10.6597C17.8173 9.88294 18.7928 9.50098 19.7885 9.51095L15.7142 9.47014C14.7185 9.46016 13.743 9.84213 12.9979 10.6189C12.3072 11.339 11.8856 12.3387 11.8974 13.4482L15.1966 30.3943C15.2084 31.5037 14.7868 32.5035 14.0961 33.2236C13.3509 34.0004 12.3755 34.3823 11.3797 34.3723L15.454 34.4132C16.4498 34.4231 17.4252 34.0412 18.1703 33.2644C18.8611 32.5443 16.8885 31.033 16.8767 29.9235Z",
    fill: "#FCE3A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1634 33.194C22.0436 32.0698 22.0166 30.4631 22.6951 29.3126C23.0593 28.6952 22.6037 27.8879 21.8695 27.8879H12.21C9.63216 27.8879 8.31855 31.2573 10.2478 33.194C11.0949 34.0444 12.2052 34.4697 13.3156 34.4697H26.2313C25.1209 34.4697 24.0106 34.0444 23.1634 33.194Z",
    fill: "#FFCE71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0911 21.6353L19.8234 21.7044C19.2759 21.7211 18.8455 22.1808 18.8621 22.7311C18.8787 23.2814 19.336 23.714 19.8835 23.6973L22.1511 23.6282C22.6986 23.6115 23.129 23.1519 23.1124 22.6016C23.0959 22.0513 22.6385 21.6187 22.0911 21.6353Z",
    fill: "#373737",
    fillOpacity: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0415 16.9958L22.631 16.8862C23.1785 16.8695 23.6089 16.4098 23.5924 15.8595C23.5758 15.3092 23.1185 14.8766 22.571 14.8933L18.9816 15.0029C18.4341 15.0197 18.0037 15.4793 18.0202 16.0296C18.0368 16.5799 18.494 17.0125 19.0415 16.9958Z",
    fill: "#373737",
    fillOpacity: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3225 18.2442L18.4113 18.3942C17.8638 18.4109 17.4333 18.8706 17.4499 19.4209C17.4665 19.9712 17.9237 20.4038 18.4712 20.3871L23.3825 20.2371C23.93 20.2204 24.3604 19.7607 24.3438 19.2104C24.3273 18.6601 23.87 18.2275 23.3225 18.2442Z",
    fill: "#373737",
    fillOpacity: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3515 30.7761L27.6008 27.8583H26.5313H25.4618L24.7111 30.7761C24.6314 31.0855 24.8638 31.3872 25.1818 31.3872C25.2778 31.3872 25.3716 31.3587 25.4514 31.3051L26.5313 30.5816L27.6111 31.3051C27.691 31.3587 27.7848 31.3872 27.8808 31.3872C28.1987 31.3871 28.4311 31.0855 28.3515 30.7761Z",
    fill: "#EA5B70"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.595 28.4853C27.9732 28.4853 29.0905 27.3623 29.0905 25.977C29.0905 24.5917 27.9732 23.4688 26.595 23.4688C25.2169 23.4688 24.0996 24.5917 24.0996 25.977C24.0996 27.3623 25.2169 28.4853 26.595 28.4853Z",
    fill: "#FFB357"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "#CDCDCD",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateStep);
export default __webpack_public_path__ + "static/media/certificate_step.5b1db1b1884574cea218b7b233921690.svg";
export { ForwardRef as ReactComponent };